module.exports = __webpack_public_path__ + "img/client-vibestown.bd5d9f9b.jpg";